import { __zcAsy, __zcFin, __zcFinZ, __zcMkv, __zcPs } from "__zod-compiler-runtime__";
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'
import * as z from 'zod'
import {BasePayloadSchema} from './base-payload'
import {BreadcrumbSchema} from './breadcrumb'

/**
 * Payload schema for resource confirmation pages (e.g., after form submission).
 */
export const ResourceConfirmationPayloadSchema = /* @__PURE__ */ (() => {
var __zs=z.lazy(() =>
  BasePayloadSchema.unwrap().extend({
    breadcrumbLinks: safeOptional(z.array(BreadcrumbSchema)),
  }),
);
var __rf=[__zs._zod.innerType.shape["breadcrumbLinks"]._zod.def.innerType._zod.def.out._zod.def.transform];
var __bf_2={};
var __rfn_9=__rf[0];
function __vb_3(input){var __bv_4,__bv_5,__bs_6,__bv_7,__bx_8,__bw_10,__bo_11;if(typeof input!=="object"||input===null||Array.isArray(input))return __bf_2;__bv_4=input["userLoggedIn"];if(!((__bv_4===undefined||(typeof __bv_4==="boolean"))))return __bf_2;__bv_5=input["contentfulRawJsonResponse"];if(!(typeof __bv_5==="object"&&__bv_5!==null&&!Array.isArray(__bv_5)))return __bf_2;__bs_6=__zcPs(__bv_5);__bv_7=input["breadcrumbLinks"];if(__bv_7===undefined){__bw_10=undefined;}else{__bx_8=__rfn_9(__bv_7);if(__bx_8 instanceof Promise)__zcAsy();__bw_10=__bx_8;}__bo_11={"contentfulRawJsonResponse":__bs_6};if(__bv_4!==undefined||("userLoggedIn" in input)){__bo_11["userLoggedIn"]=__bv_4;}if(__bw_10!==undefined||("breadcrumbLinks" in input)){__bo_11["breadcrumbLinks"]=__bw_10;}return __bo_11;}
var __rfm_z=__zs.safeParse;
function safeParse_ResourceConfirmationPayloadSchema(input){
var __bd_12=__vb_3(input);
if(__bd_12!==__bf_2){return{success:true,data:__bd_12};}
return __zcFinZ(__rfm_z,__zs,input);
}
return __zcMkv(safeParse_ResourceConfirmationPayloadSchema,__zs,null,null);
})()

export type ResourceConfirmationPayload = z.infer<typeof ResourceConfirmationPayloadSchema>

export function toResourceConfirmationPayload(payload: unknown): ResourceConfirmationPayload {
  return ResourceConfirmationPayloadSchema.parse(payload)
}
